module.exports = __webpack_public_path__ + "static/img/wisdomBanner.7c3a2a45.png";